<div class="modal-header" appCustomAutofocus>
    <h3>Send Onboarding Invitation</h3>
</div>
<div class="modal-body">
    <form #invitationForm="ngForm">
        <div class="row">
            <div class="col-lg-12">
                <b>If the employee exists in the Resource Master, select below:</b>
                <ng-select name="formData.employeeLabel"
                           [items]="employee$ | async"
                           [hideSelected]="true"
                           [multiple]="false"
                           [typeahead]="employeeInput$"
                           bindLabel="DisplayName"
                           [loading]="employeeLoading"
                           [clearable]="false"
                           typeToSearchText="Please enter 2 or more characters"
                           [virtualScroll]="true"
                           placeholder="Existing Employee? Select here..."
                           [(ngModel)]="formData.employee"
                           (change)="employeeUpdate()"
                           dropdownPosition="bottom">
                </ng-select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12"><span>Otherwise, input the new hire's information below:</span></div>
        </div>
        <hr />
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>First Name:</strong></label><span style="color:red;">*</span>
                    <input type="text" name="firstName" class="form-control" [(ngModel)]="formData.firstName" required/>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Last Name:</strong></label><span style="color:red;">*</span>
                    <input type="text" name="lastName" class="form-control" [(ngModel)]="formData.lastName" required/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Email:</strong></label><span style="color:red;">*</span>
                    <input type="email" name="email" class="form-control" [(ngModel)]="formData.email" required/>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Profile:</strong></label><span style="color:red;">*</span>
                    <ng-select [searchable]="false"
                               [clearable]="false"
                               dropdownPosition="bottom"
                               [(ngModel)]="formData.profile"
                               [ngClass]="{'is-invalid': !formData.profile}"
                               (change)="getAllDefaultsList()"
                               required>
                        <ng-option *ngFor="let profile of profileList" [value]="profile.OnboardProfileID">{{profile.OnboardProfileName}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="showCheckSSN && formData.employee == null" style="margin-bottom: 12px;">
            <div class="col-lg-6">
                <label><strong>SSN:</strong></label><span style="color:red;">*</span>
                <input type="text" 
                       name="noHireCheck"
                       class="form-control" 
                       [(ngModel)]="formData.noHireCheck"
                       placeholder="___-__-____"
                       (blur)="checkSSN()"
                       required
                       appSsnFormat (valueChange)="updateFormdata($event,'noHireCheck')"/>
            </div>
        </div>
        <!--<div class="alert alert-warning" role="alert" *ngIf="formData.profile.IncludeW4 || formData.profile.IncludeI9">W-4 and/or I-9 and Identification will be included in the onboarding tasks.</div>-->
        <div class="row">
            <div class="col-lg-8">
                <label><strong>Add Step:</strong></label>
                <ng-select name ="taskToAdd"
                           [searchable]="false"
                           [clearable]="false"
                           dropdownPosition="bottom"
                           [(ngModel)]="formData.taskToAdd">
                    <ng-option *ngFor="let unusedProcess of unusedProcesses" [value]="unusedProcess">{{unusedProcess.StepName}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <button type="button" 
                        class="btn btn-primary buttonNoLabel"
                        style="margin-top:28px"
                        (click)="addProcess()"
                        [disabled]="formData.taskToAdd == null">
                    <i class="modus-icons align-bottom">add</i> Add
                </button>
            </div>
        </div>
        <br />
        <div class="row" *ngIf="processes.length > 0 || unusedProcesses.length > 0">
            <div class="col-lg-12" style="max-height:300px;overflow:auto;">
                <table class="table">
                    <thead>
                        <tr>
                            <th>
                                Step Name
                            </th>
                            <th>

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let process of processes;let $index = index">
                            <td>{{process.StepName}}</td>
                            <td><a [href]="" *ngIf="!process.OnboardTaskIsRequired" (click)="removeTask($index)" class="blacktext" style="cursor:pointer">Remove</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="sendClicked()" [disabled]="invitationForm.form.invalid">Send</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>